const NAME = "GOALS_AND_OBJETIVES";

export default NAME;
